import { defineComponent as r, inject as p, computed as l, createElementBlock as c, openBlock as m, mergeProps as u, unref as n, createElementVNode as f, normalizeClass as h, renderSlot as P } from "vue";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DataList/data-list.js";
import { DataListItemKey as v } from "./DataListItem.vue2.js";
import { useOUIAProps as y } from "../../helpers/ouia.js";
const B = ["hidden"], E = /* @__PURE__ */ r({
  name: "PfDataListContent",
  __name: "DataListContent",
  props: {
    noPadding: { type: Boolean },
    hidden: { type: Boolean, default: void 0 },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(d) {
    const e = d, i = y({ id: e.ouiaId, safe: e.ouiaSafe }), o = p(v), s = l(() => e.hidden !== void 0 ? e.hidden : !(o != null && o.expandable.value && o.expanded.value));
    return (a, C) => (m(), c("section", u(n(i), {
      class: n(t).dataListExpandableContent,
      hidden: s.value
    }), [
      f("div", {
        class: h([
          n(t).dataListExpandableContentBody,
          {
            [n(t).modifiers.noPadding]: a.noPadding
          }
        ])
      }, [
        P(a.$slots, "default")
      ], 2)
    ], 16, B));
  }
});
export {
  E as default
};
